import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../Loader/Loader';

var ComponentWithLoader = function ComponentWithLoader(_ref) {
  var showLoader = _ref.showLoader,
      children = _ref.children;
  return showLoader ? React.createElement('div', {
    style: {
      height: '100vh'
    }
  }, React.createElement(Loader, {
    loading: true
  })) : React.createElement(React.Fragment, null, children);
};

ComponentWithLoader.propTypes = {
  showLoader: PropTypes.bool,
  children: PropTypes.node
};
export default ComponentWithLoader;